import { Component } from "react"

/* Input Mask */
import InputMask from "@mona-health/react-input-mask"


/* Component Input */
class Input extends Component {

    constructor() {
        super()

        this.state = {
            focused: false,
            secured: true,
            error: "",
        }
    }

    /* Show Error */
    error = (error) => this.setState({ error })

    /* On Focus */
    focus = () => {

        /* Fields */
        const { clear } = this.props

        /* Check */
        if (clear !== null && clear !== undefined) {
            clear()
        }

        this.setState({ focused: true, error: "" })
    }

    /* On Blur */
    blur = () => {

        /* Fields */
        const { clear } = this.props

        /* Check */
        if (clear !== null && clear !== undefined) {
            clear()
        }

        this.setState({ focused: false, error: "" })
    }


    /* Draw Error */
    _error = () => {

        /* Fields */
        const { error } = this.state

        if (error !== "") {
            return <div className="form-input-error">{error}</div>
        }
    }

    /* Draw Secure Eye */
    _eye = () => {

        /* Fields */
        const { secure } = this.props
        const { secured } = this.state

        /* Check Secure */
        if (secure) {
            return (
                <div className="form-input-secure" onClick={() => this.setState({ secured: !secured })}>
                    {secured ? <img src="/images/eye.png" alt="Eye" /> : <img src="/images/eye-off.png" alt="Eye Off" />}
                </div>
            )
        }

    }

    /* Draw Label */
    _label = () => {

        /* Fields */
        const { label } = this.props
        const { focused } = this.state

        return <div onClick={() => !focused && this._box.focus()} className="form-input-label">{label}</div>
    }


    /* Draw Input */
    _input = () => {

        /* Fields */
        const { value, secure, mask, ...props } = this.props
        const { secured } = this.state

        /* Mask */
        if (mask) {
            return <InputMask {...props} mask={mask} value={value} onFocus={() => this.focus()} onBlur={() => this.blur()} ref={(ref) => this._box = ref} type={(secure && secured) ? "password" : "text"} />
        }

        /* Default */
        return <input {...props} value={value} onFocus={() => this.focus()} onBlur={() => this.blur()} ref={(ref) => this._box = ref} type={(secure && secured) ? "password" : "text"} />
    }

    render = () => {

        /* Fields */
        const { value, label, file, disabled, ...props } = this.props
        const { focused } = this.state

        /* Determine Focused */
        let _focused = ""
        if (focused || value !== "") {
            _focused = "form-input-focused"
        }

        /* Determine Disabled */
        let _disabled = ""
        if (disabled) {
            _disabled = "disabled"
        }

        /* File */
        if (file) {
            return (
                <div className="form-input form-input-focused">
                    <div className="form-input-label">{label}</div>
                    <input {...props} type="file" />
                </div>
            )
        }

        return (
            <div className={`form-input ${_focused} ${_disabled}`}>

                {/* Draw Label */}
                {this._label()}

                {/* Draw Input */}
                {this._input()}

                {/* Draw Secure Eye */}
                {this._eye()}

                {/* Draw Error */}
                {this._error()}

            </div>
        )
    }

}

export default Input